import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { AppError, PropertyDetails, ReleasedConnection, ReleasedPropertiesList } from '@core/api';

export const featureConnectionActions = createActionGroup({
  source: 'Map/Feature',
  events: {
    'Fetch Property Management': emptyProps,
    'Fetch Property Management Success': props<{
      releasedConnection: ReleasedConnection;
      allUsersPro: boolean;
    }>(),
    'Fetch Property Management Fail': props<{ error: AppError }>(),

    'Fetch Property Areas List': emptyProps,
    'Fetch Property Areas List Success': props<{ data: ReleasedPropertiesList }>(),
    'Fetch Property Areas List Fail': props<{ error: AppError }>(),

    'Manage Feature Connection': props<{
      propertyId?: string;
    }>(),

    'Fetch Property Details': emptyProps,
    'Fetch Property Details Success': props<{ data: PropertyDetails }>(),
    'Fetch Property Details Fail': props<{ error: AppError }>(),

    'Leave Tab': emptyProps,

    'Filter Properties': props<{ search: string }>(),
  },
});
